import billingModule from '../../billing.module';
import template from './billingIconProduct.component.html';
import style from './billingIconProduct.component.css';

export default billingModule.component('billingIconProduct', {
    template,
    style,
    bindings: {
        iconSrc: '<'
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-icon-product/billingIconProduct.component.js